
export function cast<T, R>(object: T): R {
  return object as unknown as R;
}

export function clone<T, R>(object: T): R {
  return JSON.parse(JSON.stringify(object)) as R;
}